const doubleTapConfig = {
  minFontSize: 1.0,
  maxFontSize: 1.8,
  doubleTapDelay: 300,
  clickedPlace: window.innerWidth / 2
};

export default doubleTapConfig;
